import { DateTime } from 'luxon'

export const formatDateTSX = (date: any, form: string, localTime = true) => {
  if (!date) return ''
  date = new Date(date)
  const dateTime = localTime
    ? DateTime.fromJSDate(date).toLocal()
    : DateTime.fromJSDate(date).toUTC()
  return dateTime.toFormat(form, { locale: 'pt-BR' })
}
